module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/ui/analytics-1-16976d74ca3893ca412d55449854f615.png";